export default __webpack_public_path__ + "static/media/NewWebGroup总部_white.f9f80620.jpg";